"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("../coreProduct/index"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
var _default = exports.default = {
  name: 'StoreIndex',
  components: {
    storeIndex: _index.default
  },
  created: function created() {},
  mounted: function mounted() {}
};